module.exports = __webpack_public_path__ + "img/yundongleiyouxi.4effd2ca.png";